// H5 finance module routes.
import type { RouteRecordRaw } from "vue-router";

export const financeRoutes: RouteRecordRaw[] = [
  {
    path: "/wallet/payout-methods",
    name: "payout-methods",
    component: () => import("@/modules/finance/pages/PayoutMethodsPage.vue"),
  },
  {
    path: "/wallet/payout-methods/paypal",
    name: "payout-paypal",
    component: () => import("@/modules/finance/pages/PayPalPayoutPage.vue"),
  },
  {
    path: "/wallet/payout-methods/cashapp",
    name: "payout-cashapp",
    component: () => import("@/modules/finance/pages/CashAppPayoutPage.vue"),
  },
  {
    path: "/wallet/payout-methods/bitcoin",
    name: "payout-bitcoin",
    component: () => import("@/modules/finance/pages/BitcoinPayoutPage.vue"),
  },
  {
    path: "/wallet/payout-methods/card",
    name: "payout-card",
    component: () => import("@/modules/finance/pages/BankCardPayoutPage.vue"),
  },
  {
    path: "/wallet/topup",
    name: "wallet-topup",
    component: () => import("@/modules/finance/pages/TopUpPage.vue"),
  },
  {
    path: "/wallet/transactions",
    name: "transactions",
    component: () => import("@/modules/finance/pages/TransactionsPage.vue"),
  },
  {
    path: "/wallet/withdraw",
    name: "withdraw",
    component: () => import("@/modules/finance/pages/WithdrawPage.vue"),
  },
  {
    path: "/wallet/withdrawals/:withdrawalId",
    name: "withdrawal-detail",
    component: () => import("@/modules/finance/pages/WithdrawalDetailsPage.vue"),
  },
];
